import React from 'react';
import { useSelector } from 'react-redux';

import withWidgetTestId from '@swf/core/hoc/withWidgetTestId';
import type { WidgetFC } from '@swf/core/types/Widget';
import { TryAgainMessage } from '@swf/sports/components';

import styles from './SportsAntePostEventsWidget.scss';
import EventPanel from './components/EventPanel/EventPanel';
import NoAntePostEventsMessage from './components/NoAntePostEventsMessage/NoAntePostEventsMessage';
import { sportsAntePostEventsWidgetModel, useSportsAntePostEventsWidget } from './model';
import { isAntePostTemplateViewGroupedByDate } from './utils/isAntePostTemplateViewGroupedByDate';

const SportsAntePostEventsWidget: WidgetFC = () => {
  const { widgetSelect } = useSportsAntePostEventsWidget();
  const templateGroups = useSelector(widgetSelect.templateGroups);
  const isLoading = useSelector(widgetSelect.isLoading);
  const hasPreloaded = useSelector(widgetSelect.hasPreloaded);
  const hasErrored = useSelector(widgetSelect.hasErrored);

  if (hasErrored) {
    return <TryAgainMessage />;
  }

  if (hasPreloaded && !isLoading && !templateGroups.length) {
    return <NoAntePostEventsMessage />;
  }

  return (
    <>
      {templateGroups.map((eventGroup) => {
        const isGroupedByDate = isAntePostTemplateViewGroupedByDate(eventGroup);

        const firstTemplateInPanel = isGroupedByDate
          ? eventGroup[0][0].template
          : eventGroup[0].template;

        return (
          <EventPanel
            key={`${firstTemplateInPanel.marketId}_event_panel`}
            eventGroup={eventGroup}
            marketId={firstTemplateInPanel.marketId}
          />
        );
      })}
    </>
  );
};

SportsAntePostEventsWidget.model = sportsAntePostEventsWidgetModel;

export default withWidgetTestId(SportsAntePostEventsWidget, 'sports-ante-post-events', {
  className: styles.wrapper
});
